import React from "react";
import {
  SimpleForm,
  Edit,
  ArrayInput,
  SimpleFormIterator,
  DateInput,
  SelectInput,
  ReferenceInput,
  NumberInput,
  FormDataConsumer,
  AutocompleteInput,
  GET_LIST
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TodayIcon from "@material-ui/icons/Today";
import { styles } from "../../layout/Styles";
import {
  Receipt,
  CallReceived,
  CallMade,
  PersonOutline
} from "@material-ui/icons";
import { DataProvider } from "../../providers";

export class RemitosEditComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materialesList: [
        {
          id: "",
          nombre: "",
          pesoXUnidad: 0,
          precio: 0,
          precioCosto: 0,
          unidad: ""
        }
      ]
    };
  }

  componentDidMount() {
    DataProvider(GET_LIST, "materiales", {
      field: "nombre",
      order: "ASC"
    }).then(response => {
      const materialesList = response.data;
      this.setState({
        materialesList
      });
    });
  }

  materialPeso = record => {
    let peso = 1;
    let id = record.material;
    let cantidad = record.cantidad;
    for (let i = 0; i < this.state.materialesList.length; i++) {
      if (
        id === this.state.materialesList[i].id &&
        this.state.materialesList[i].pesoXUnidad
      ) {
        return (peso = this.state.materialesList[i].pesoXUnidad * cantidad);
      }
    }
    return peso;
  };
  render() {
    return (
      <Edit title="Editar Pesaje" {...this.props}>
        <SimpleForm redirect="/remitos">
          <Grid container spacing={0}>
            <Grid item xs={12} md={4}>
              <Paper style={styles.paperIcon}>
                <Receipt style={styles.iconLeft} />
                <NumberInput
                  label="Número de salida"
                  source="numero"
                  fullWidth
                />
              </Paper>
              <Paper style={styles.paperIcon}>
                <TodayIcon style={styles.iconLeft} />
                <div>
                  <DateInput label="Fecha" source="fecha" fullWidth />
                </div>
              </Paper>
              <Paper style={styles.paperIcon}>
                <PersonOutline style={styles.iconLeft} />
                <div>
                  <ReferenceInput reference="operarios" source="operario">
                    <SelectInput
                      optionText="nombre"
                      optionValue="_id"
                      fullWidth
                    />
                  </ReferenceInput>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container xs={12}>
                <Grid item xs={6}>
                  <Paper style={styles.paperIcon}>
                    <CallMade style={styles.iconLeft} />
                    <div>
                      <ReferenceInput
                        reference="entidades"
                        source="vendedor"
                        filter={{ vendedor: true }}
                      >
                        <SelectInput
                          optionText="nombre"
                          optionValue="_id"
                          fullWidth
                        />
                      </ReferenceInput>
                    </div>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper style={styles.paperIcon}>
                    <CallReceived style={styles.iconLeft} />
                    <ReferenceInput
                      label="Comprador"
                      reference="entidades"
                      source="comprador"
                      sort={{ field: "nombre", order: "ASC" }}
                      filterToQuery={searchText => ({
                        nombre: { $regex: `(?i).*${searchText}.*(?-i)` },
                        comprador: true
                      })}
                    >
                      <AutocompleteInput
                        optionText="nombre"
                        optionValue="_id"
                        fullWidth
                      />
                    </ReferenceInput>
                  </Paper>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Paper
                  style={styles.paper}
                  className="materiales materialesremito"
                >
                  <ArrayInput source="materiales">
                    <SimpleFormIterator>
                      <SelectInput
                        source="material"
                        optionText={<Material />}
                        optionValue="id"
                        choices={this.state.materialesList}
                      />
                      <NumberInput
                        label="Cantidad"
                        source="cantidad"
                        defaultValue={1}
                      />
                      <FormDataConsumer>
                        {({ formData, scopedFormData, getSource, ...rest }) => (
                          <NumberInput
                            label="Peso estimado"
                            source={getSource("pesoEstimado")}
                            InputProps={{
                              value: scopedFormData
                                ? this.materialPeso(scopedFormData)
                                : null
                            }}
                          />
                        )}
                      </FormDataConsumer>
                      <NumberInput label="Peso manual" source="pesoReal" />
                    </SimpleFormIterator>
                  </ArrayInput>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
    );
  }
}

const Material = ({ record }) => {
  return `${record.nombre} (${record.unidad})`;
};



// WEBPACK FOOTER //
// ./src/components/Remitos/RemitosEditComponent.js